import requests from "/src/utils/requests"
import permission from "./permission"
import sensitive from "./sensitive"

const getUserInfo = function (){
	return requests({
		url: "/profile",
		method: "get",
	})
}

const login = ({ phone, password })=> {
    return requests({
        url: "/login",
        method: "post",
        data: { phone, password }
    })
}

const sendMsg = ({ mobile})=> {
    return requests({
        url: "/sendSms",
        method: "post",
        data: { mobile,pc:1}
    })
}


const getUserDetail = function ({id}){
    return requests({
        url: `/user/userDetail`,
        method: "get",
        params: {
            id
        }
    })
}

const generateAccount = function ({mobile, tenantCode}){
    return requests({
        url: `/user/generateAccount`,
        method: "get",
        params: {
            mobile,
            tenantCode
        }
    })
}

const resetPassword = function ({id ,mobile}){
    return requests({
        url: `/user/resetPassword`,
        method: "put",
        data: {
            id,
            mobile,
        }
    })
}

const verifyPassword = function ({id , password}){
    return requests({
        url: `/user/verifyPassword`,
        method: "post",
        data: {
            id,
            password,
        }
    })
}

const logout = ()=> {
    return requests({
        url: "/user/logout",
        method: "get",
        params: {}
    })
}

export default {
    getUserInfo,
    login,
    getUserDetail,
    generateAccount,
    resetPassword,
    verifyPassword,
    ...permission,
    ...sensitive,
    logout,
	sendMsg
}
